import { getStaticJSON } from './_helpers';

export async function fetchShowcase(lang) {
  return await getStaticJSON(`/rokinvitrine/${lang}.json`);
}

export async function fetchShowcaseTour() {
  return await getStaticJSON('/rokinvitrine/tour.json');
}



// WEBPACK FOOTER //
// ./src/api/showcase.js